<template>
  <div class="dashboard-container error-container d-flex justify-content-center">
    <div class="dashboard-content d-flex flex-column">
      <div class="card mb-3">
        <div class="card-header text-white">
          <h5 class="mb-0"><strong>Error 404</strong></h5>
        </div>
        <div class="card-body bg-light">
          <h5 class="card-title mb-4">{{ $t('global.not_found') }}</h5>
          <div class="mt-4 pt-4">
            <router-link :to="{ name: 'projects' }">
              <button type="button" class="btn btn-medium btn-orange-dark">
                <corner-down-left-icon></corner-down-left-icon>
                <span>{{ $t('global.back') }}</span>
              </button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CornerDownLeftIcon } from 'vue-feather-icons'

export default {
  name: 'NotFound',

  components: { CornerDownLeftIcon }
}
</script>
